import React from 'react';
import './railClock.css';

/**
 * RailClock — the mobile-LANDSCAPE rail's top clock block, SHARED by Live's `.live-landscape-bar` and
 * playback's `.mcpb-rail` so the two rails stay cohesive (David #86bb7phhh). One component, one stylesheet
 * — no more dual clock styling.
 *
 * Layout: date + time on ONE line; retention days + the System-details ⓘ on a compact second line.
 * Theme-var driven (secondary/muted ink) so it renders identically in both rails and both themes.
 *
 * Props: date, time (strings from formatNvrClock); daysRec (number|null — hidden when null);
 *        onInfo (fn|undefined — the ⓘ button is omitted when not provided).
 */
const RailClock = ({ date, time, daysRec, onInfo }) => (
  <div className="rail-clock" data-testid="rail-clock">
    <div className="rail-clock__primary">
      <span className="rail-clock__date">{date}</span>
      <span className="rail-clock__time">{time}</span>
    </div>
    {(daysRec != null || onInfo) && (
      <div className="rail-clock__meta">
        {daysRec != null && (
          <span className="rail-clock__days">{daysRec} {daysRec === 1 ? 'Day' : 'Days'}</span>
        )}
        {onInfo && (
          <button
            type="button"
            className="rail-clock__info"
            title="System details"
            aria-label="System details"
            onClick={onInfo}
          >
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" /></svg>
          </button>
        )}
      </div>
    )}
  </div>
);

export default RailClock;
